import { render, staticRenderFns } from "./postManagement.vue?vue&type=template&id=eb7b05b4&scoped=true"
import script from "./postManagement.vue?vue&type=script&lang=js"
export * from "./postManagement.vue?vue&type=script&lang=js"
import style0 from "./postManagement.vue?vue&type=style&index=0&id=eb7b05b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7b05b4",
  null
  
)

export default component.exports